import { render, staticRenderFns } from "./rotatingFerrisWheel.vue?vue&type=template&id=6dce2c38&scoped=true&"
import script from "./rotatingFerrisWheel.vue?vue&type=script&lang=js&"
export * from "./rotatingFerrisWheel.vue?vue&type=script&lang=js&"
import style0 from "./rotatingFerrisWheel.vue?vue&type=style&index=0&id=6dce2c38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce2c38",
  null
  
)

export default component.exports